import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Breadcrumb} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import ProviderData from "../../data/ProviderData";
import CustomDivider from '../../components/extras/CustomDivider';
import DynamicTable from "../../components/extras/DynamicTable";
import {showToast} from "../../actions/ToastAction";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import connect from "react-redux/es/connect/connect";
import {providerDialog} from "../../actions/ProviderDialogAction";
import QuestionDialog from "../../components/extras/QuestionDialog";
import localDB from "../../data/localDB";
import {ws_store} from "../../components/sockets/SocketStore";


class Providers extends Component {

    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Nombre', 'Razón Social', 'Email', 'Teléfono', 'Acciones'],
                name: 'Proveedor',
                title: 'Proveedores',
                has_actions: true,
                edit: true,
                can_add: true,
                pagination: true,
                delete: true,
                url: 'providers',
                values: ['id', 'full_name', 'factory', 'phone', 'email'],
                id: 'table_providers'
            }
        };
        this.delete = this.delete.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.provider_select && nextProps.provider_select.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.provider_select);
        }
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.providerDialog({open:true, provider:{id:null, phone_prefix:'+57'}});
        }else if(response.event === 'edit'){
            this.props.providerDialog({open:true, provider:response.data});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        }
    };

    async delete(id) {
        ProviderData.delete(id, (res) => {
            if (res === null) {
                this.props.dynamicTableDelete(id);
                localDB.deleteDB('providers', id);
                this.props.showToast({message: 'Proveedor Borrado!', type: 'success'});
                ws_store.send(JSON.stringify({
                    id,
                    payload: {
                        type: 'provider',
                        action: 'delete',
                        sender: localDB.get('user').username
                    }
                }));
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'success'});
            }
        });
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Proveedores | Contactos - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/contacts'>Contactos</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Proveedores</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <QuestionDialog ref="deleteDialog" message="Borrar este proveedor" callbackConfirm={this.delete}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        provider_select: state.get('provider_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(data){
            dispatch(showToast(data))
        },
        providerDialog(data){
            dispatch(providerDialog(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Providers);


// WEBPACK FOOTER //
// ./src/containers/contacts/Providers.js